import PartyFormation from "../../../../src/components/Suikoden/TacticsGrid.jsx";
import React from 'react';
export default {
  PartyFormation,
  React
};